import { render, staticRenderFns } from "./CampaignOffers.vue?vue&type=template&id=50f7b9e5&scoped=true"
import script from "./CampaignOffers.vue?vue&type=script&lang=js"
export * from "./CampaignOffers.vue?vue&type=script&lang=js"
import style0 from "./CampaignOffers.vue?vue&type=style&index=0&id=50f7b9e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7b9e5",
  null
  
)

export default component.exports